import React, { FC } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { Breadcrumb, BreadCrumbItem } from 'src/Components/Breadcrumb'
import { APP } from 'src/Configs/App'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'

const NAVIGATE_BACK_INDEX = -1

const getBreadcrumbItems = (pathname: string): BreadCrumbItem[] => {
  const items: BreadCrumbItem[] = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign type',
      path: ArtistRoutesEnum.ChooseCreateCampaignPlatform,
    },
  ]

  if (
    APP.PRE_RELEASE_CAMPAIGNS_ENABLED &&
    pathname.startsWith(ArtistRoutesEnum.ChooseCreateCampaignPlatformSpotify)
  ) {
    items.push({
      title: 'Release type',
      path: ArtistRoutesEnum.ChooseCreateCampaignReleaseType,
    })
  }

  items.push({
    title:
      pathname === ArtistRoutesEnum.CreatePreReleaseTrackDetails
        ? 'Track details'
        : 'Track search',
    path: '',
  })

  return items
}

export const CreateCampaignBreadcrumbsAuth: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const breadcrumbItems = getBreadcrumbItems(pathname)

  const onBreadcrumbButtonClick = (): void => {
    navigate(NAVIGATE_BACK_INDEX)
  }

  const filteredBreadcrumbItems: BreadCrumbItem[] = breadcrumbItems.reduce<{
    items: BreadCrumbItem[]
    found: boolean
  }>(
    (acc, item) => {
      if (acc.found) {
        return acc
      }
      acc.items.push(item)
      if (item.path === pathname) {
        acc.found = true
      }
      return acc
    },
    { items: [], found: false },
  ).items

  return (
    <Breadcrumb
      items={filteredBreadcrumbItems}
      onButtonClick={onBreadcrumbButtonClick}
    />
  )
}
